import { SxProps, Theme } from '@mui/material';
import { AI_GRADIENT_CSS as AI_GRADIENT, aiGradientTextSx } from 'common/constants/ai';

export const toolbarContainerSx: SxProps<Theme> = {
  display: 'flex',
  gap: 1,
  alignItems: 'center',
  my: 0.5,
};

export const createLabelsButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  whiteSpace: 'nowrap',
  border: 'none',
  py: 0.25,
  px: 1,
  minHeight: 0,
  lineHeight: 1.2,
  fontSize: '0.75rem',
  '&:hover': {
    border: 'none',
    backgroundColor: 'transparent',
  },
};

export const pushMappingsButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  whiteSpace: 'nowrap',
  py: 0.5,
  px: 1.5,
  lineHeight: 1.2,
  fontSize: '0.75rem',
  flexShrink: 0,
  // Do not set minHeight: 0 (copied from text-only controls): it can collapse a contained
  // Button in the zoomed tab app bar, leaving only padding (~4px) and invisible label text.
};

export const aiIconSx: SxProps<Theme> = {
  width: 16,
  height: 16,
  marginRight: 0.5,
  marginTop: '4px',
};

export const menuItemAiIconSx: SxProps<Theme> = {
  width: 14,
  height: 14,
  marginRight: 1,
};

export const aiMenuItemTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 500,
};

export const createLabelsTextSx: SxProps<Theme> = {
  ...(aiGradientTextSx as Record<string, unknown>),
  fontWeight: 600,
  textTransform: 'none',
  fontSize: '0.75rem',
  py: 0.25,
  px: 1.25,
  minHeight: 0,
  lineHeight: 1.4,
  display: 'flex',
  alignItems: 'center',
  '&:hover': {
    filter: 'brightness(0.9)',
    background: AI_GRADIENT,
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  '&.Mui-disabled': { background: AI_GRADIENT, opacity: 0.45, color: 'white' },
};

export const popperSx: SxProps<Theme> = {
  zIndex: 1,
};
